var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 2.8C13.006 2.8 13.335 2.94 13.594 3.213C13.86 3.5 14 3.815 14 4.2V11.9C14 12.285 13.86 12.6 13.594 12.887C13.335 13.16 13.006 13.3 12.6 13.3H1.4C0.994 13.3 0.665 13.16 0.406 12.887C0.14 12.6 0 12.285 0 11.9V4.2C0 3.815 0.14 3.5 0.406 3.213C0.665 2.94 0.994 2.8 1.4 2.8H4.2V1.4C4.2 0.994 4.34 0.665 4.606 0.406C4.865 0.14 5.194 0 5.6 0H8.4C8.806 0 9.135 0.14 9.394 0.406C9.66 0.665 9.8 0.994 9.8 1.4V2.8H12.6ZM1.4 4.2V11.9H12.6V4.2H1.4ZM8.4 2.8V1.4H5.6V2.8H8.4ZM7 4.9C7.41772 4.9 7.81832 5.06594 8.11369 5.36131C8.40906 5.65668 8.575 6.05728 8.575 6.475C8.575 7.35 7.868 8.05 7 8.05C6.58228 8.05 6.18168 7.88406 5.88631 7.58869C5.59094 7.29332 5.425 6.89272 5.425 6.475C5.425 5.6 6.132 4.9 7 4.9ZM10.15 11.2H3.85V10.416C3.85 9.541 5.25 8.841 7 8.841C8.75 8.841 10.15 9.541 10.15 10.416V11.2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.48b2a44c.svg";
export { ForwardRef as ReactComponent };